module.exports = __webpack_public_path__ + "static/media/damlag2_1366.a84e9757.jpg";